import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import useGmdUserInfo from '../../hooks/gmdUserInfo';
import { graphql } from '../../__generated__';
import { useQuery } from '@apollo/client';
import { Alert, Box, Container, LinearProgress } from '@mui/material';
import { ClientRate_ItemFragmentFragment } from '../../__generated__/graphql';

export const getTransactionServiceQuery = graphql(/* GraphQL */ `
  query GetTransactionService($serviceId: ID!) {
    service(id: $serviceId) {
      serviceid
      merchant
      title
      description
      category
      country
      localCur
      type
      status
      isReqCustomerName
      isReqCustomerAddress
      isReqCustomerNumber
      isReqServiceNumber
      denomination
      isVerifiable
      validationMask
      hint {
        language
        localText
      }
      labelCustomerNumber {
        language
        localText
      }
      labelServiceNumber {
        language
        localText
      }
    }
  }
`);

export const getTenantRatesQuery = graphql(/* GraphQL */ `
  query Rates($tenantId: String!) {
    rates(tenantId: $tenantId) {
      ...ClientRate_ItemFragment
    }
  }
`);

const ServiceIntakeForm = (props: any) => {
  const { userInfo } = useGmdUserInfo();
  const params = useParams();
  const { type, serviceid } = params;
  const { data, loading, error, refetch } = useQuery(
    getTransactionServiceQuery,
    {
      variables: { serviceId: serviceid || '0' },
    }
  );
  const tenantId = userInfo.tenant || '';
  const {
    data: rates,
    loading: ratesLoading,
    error: ratesError,
  } = useQuery(getTenantRatesQuery, {
    variables: { tenantId: tenantId || '' },
    skip: (tenantId || '')?.length === 0,
  });

  const [serviceLoaded, setServiceLoaded] = useState<Boolean>(false);
  const [ServiceItemFormContainer, setServiceItemFormContainer] =
    useState<React.ComponentType | null>(null);
  const [tenantRates, setTenantRates] = useState<
    ClientRate_ItemFragmentFragment[]
  >([]);

  const [report] = useState(type);

  useEffect(() => {
    if (report && !serviceLoaded) {
      const reportPath = `./${report}Form`;
      import(`${reportPath}`)
        .then((component) => {
          setServiceItemFormContainer(() => component.default);
          setServiceLoaded(true);
        })
        .catch((error) => {
          console.error(error);
          setServiceItemFormContainer(null);
        });
    }
  }, [report, serviceLoaded]);

  useEffect(() => {
    if (rates?.rates) {
      const rateFragments: ClientRate_ItemFragmentFragment[] = [];
      rates.rates.forEach((rate) => {
        if (rate) {
          const rateFragment = rate as ClientRate_ItemFragmentFragment;
          rateFragments.push(rateFragment);
        }
      });
      setTenantRates(rateFragments);
    }
  }, [rates?.rates]);

  return (
    <Container fixed>
      {(loading || ratesLoading) && (
        <Box m={1}>
          <LinearProgress />
        </Box>
      )}
      {(error || ratesError) && (
        <Alert severity="error" onClose={() => refetch()}>
          {error?.message || ratesError?.message || 'An error occured'}
        </Alert>
      )}
      {tenantRates.length > 0 &&
        data &&
        userInfo &&
        ServiceItemFormContainer && (
          <ServiceItemFormContainer
            {...props}
            rates={tenantRates}
            params={params}
            serviceData={data}
            user={userInfo}
            language={'en'}
          />
        )}
    </Container>
  );
};

export default ServiceIntakeForm;
